import React, { useState } from "react";
import { Button, Form, Divider } from "semantic-ui-react";
import Invoice from "../common/Invoice";
import LogoUpload from "../common/LogoUpload";
import Agreements from "./Agreements";
import Candidate from "../common/Candidate";
import { EmptyForm, EmptySubmission, FormSchema, EmptySubmitter, EmptyLeadSubmitter } from "./model";
import Submission from "./Submission";
import Submitter from "../common/Submitter";
import InfoBlock from "./InfoBlock";
import { errorsWithPrefix } from "../common/utils";
import { set } from "lodash/object";
import ButtonWithPopup from "../common/ButtonWithPopup";
import { useExtLabels } from "../common/extLabels";

const FormPage = ({ onSubmit, termsAndConditions, withSize = true }) => {
    const l = useExtLabels();

    const [data, setData] = useState(EmptyForm);
    const [errors, setErrors] = useState({});

    const onChange = ({ name, value, key }) => {
        const newData = set({ ...data }, name, value);
        setData(newData);
    };

    const submit = e => {
        e.preventDefault();

        console.info(data);
        FormSchema.validate(data, { abortEarly: false }).then(
            () => onSubmit(data),
            reason => {
                const err = reason.inner.reduce((a, v) => ({ ...a, [v.path]: v }), {});
                console.warn(err);
                setErrors(err);
            }
        );
    };
    
    const addSubmission = e => {
        e.preventDefault();
        const subs = [...data.submissions, { ...EmptySubmission, key: data.submissions.length }];
        setData({ ...data, submissions: subs });
    };

    const removeSubmission = key => {
        const subs = data.submissions.filter(it => it.key !== key).map((it, i) => ({ ...it, key: i }));
        setData({ ...data, submissions: subs });
    };

    const allowAddingSubmission = () => data.submissions.length < 3;

    const removeSubmitter = (e, key) => {
        e.preventDefault();
        const subs = data.submitters.filter(it => it.key !== key).map((it, i) => ({ ...it, key: i }));
        const lead = subs.length > 1 ? data.leadSubmitter : null
        setData({ ...data, submitters: subs, leadSubmitter: lead });
    };

    const addSubmitter = e => {
        e.preventDefault();
        const subs = [...data.submitters, { ...EmptySubmitter, key: data.submitters.length }];
        const lead = subs.length > 2 ? data.leadSubmitter : { ...EmptyLeadSubmitter }
        setData({ ...data, submitters: subs, leadSubmitter: lead });
    };

    const allowAddingSubmitter = () => data.submitters.length < 3;

    return (
        <Form>
            <Candidate
                title={l("Nazwa zgłaszanego podmiotu")}
                model={data.candidate}
                errors={errorsWithPrefix(errors, "candidate")}
                onChange={value => onChange({ name: "candidate", value })}
                withSize={withSize}
            />
            <LogoUpload
                model={data.logo}
                errors={errorsWithPrefix(errors, "logo")}
                onChange={value => onChange({ name: "logo", value })}
            />
            {data.submitters.map(it => (
                <React.Fragment key={it.key}>
                    <Divider />
                    {data.submitters.length > 1 && (
                        <Button floated="right" negative onClick={e => removeSubmitter(e, it.key)}>
                            {l("Usuń")}
                        </Button>
                    )}
                    <h2>
                        {l("Zgłaszający")} {it.key + 1}
                    </h2>
                    <Submitter
                        key={it.key}
                        model={it}
                        errors={errorsWithPrefix(errors, `submitters[${it.key}]`)}
                        onChange={value => onChange({ name: `submitters[${it.key}]`, value })}
                    />
                    <Invoice
                        model={it.invoice}
                        errors={errorsWithPrefix(errors, `submitters[${it.key}].invoice`)}
                        onChange={value => onChange({ name: `submitters[${it.key}].invoice`, value })}
                    />
                </React.Fragment>
            ))}
            {allowAddingSubmitter() && <Button onClick={addSubmitter}>{l("Dodaj zgłaszającego")}</Button>}
            {data.submitters.length > 1 && (
                <React.Fragment>
                    <Divider />
                    <h2>{l("Dane lidera zgłoszenia")}</h2>
                    <Submitter
                        model={data.leadSubmitter}
                        errors={errorsWithPrefix(errors, `leadSubmitter`)}
                        onChange={value => onChange({ name: `leadSubmitter`, value })}
                    />
                </React.Fragment>
            )}
            <Divider />
            <InfoBlock />
            <Agreements
                termsAndConditions={termsAndConditions}
                model={data.agreements}
                errors={errorsWithPrefix(errors, "agreements")}
                onChange={value => onChange({ name: "agreements", value })}
            />
            {data.submissions.map(it => (
                <Submission
                    key={it.key}
                    model={it}
                    errors={errorsWithPrefix(errors, `submissions[${it.key}]`)}
                    onChange={value => onChange({ name: `submissions[${it.key}]`, value })}
                    onRemove={removeSubmission}
                />
            ))}
            <Form.Group inline className="actions">
                {allowAddingSubmission() && (
                    <Button onClick={addSubmission} primary={data.submissions.length === 0}>
                        {l("Dodaj kategorię")}
                    </Button>
                )}
                {data.submissions.length > 0 && (
                    <ButtonWithPopup
                        errors={errors}
                        button={
                            <Button onClick={submit} primary>
                                {l("Wyślij zgłoszenie")}
                            </Button>
                        }
                    />
                )}
            </Form.Group>
        </Form>
    );
};

export default FormPage;
